var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SvgElement } from './SvgElement';
var images = {};
var SvgPath = /** @class */ (function (_super) {
    __extends(SvgPath, _super);
    function SvgPath(props) {
        var _this = _super.call(this, { tagName: 'svg', attrs: { viewBox: props.viewBox, width: props.width, height: props.height } }, props.path.map(function (d) {
            if (typeof d === 'string') {
                return new SvgElement({ tagName: 'path', attrs: { d: d, fill: props.fill } });
            }
            else {
                var tagName = d.tagName, attrs = d.attrs;
                return new SvgElement({ tagName: tagName, attrs: __assign(__assign({}, attrs), { fill: props.fill }) });
            }
        })) || this;
        _this.id = ++SvgPath.id;
        return _this;
    }
    SvgPath.prototype.toImage = function (fill, onload) {
        if (fill === void 0) { fill = ''; }
        var key = "i".concat(this.id, "-").concat(fill);
        if (!images[key]) {
            images[key] = new Image();
            try {
                if (fill)
                    this.fill(fill);
                var blob = new Blob([this.el.cloneNode(true).outerHTML], { type: 'image/svg+xml;charset=utf-8' });
                images[key].src = URL.createObjectURL(blob);
                images[key].onload = function () { return onload && onload(); };
            }
            catch (error) {
                console.error(error);
            }
        }
        return images[key];
    };
    SvgPath.prototype.fill = function (color) {
        Array.from(this.el.childNodes).map(function (c) { return c.setAttribute('fill', color); });
    };
    SvgPath.id = 0;
    return SvgPath;
}(SvgElement));
export { SvgPath };
